export { default } from './QrNavItemGroup';



// WEBPACK FOOTER //
// ./src/components/atoms/QrNavItemGroup/index.js